import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import Text from 'common/ui/Text';
import { TextCss } from 'styles';
import {
  DIALOGS_CONFIRMATIONS_OPTIONS,
  type DialogId,
  type DialogVisibilityById,
} from './dialogSettingsRegistry';
import { DialogSettingsRow } from './DialogSettingsRow';
import {
  DialogsTable,
  HeaderCell,
  HeaderRow,
  ToggleHeaderCell,
} from './DialogSettingsTable.styles';

type DialogSettingsTableProps = {
  dialogVisibilityById: DialogVisibilityById;
  onToggleDialogVisibility: (dialogId: DialogId, visible: boolean) => void | Promise<void>;
};

export const DialogSettingsTable = ({
  dialogVisibilityById,
  onToggleDialogVisibility,
}: DialogSettingsTableProps): React.ReactElement => {
  return (
    <DialogsTable>
      <Table size="small" aria-label="dialogs and confirmations settings">
        <TableHead>
          <HeaderRow>
            <HeaderCell>
              <Text css={TextCss.body2}>Dialog</Text>
            </HeaderCell>
            <HeaderCell>
              <Text css={TextCss.body2}>Location</Text>
            </HeaderCell>
            <HeaderCell>
              <Text css={TextCss.body2}>Status</Text>
            </HeaderCell>
            <ToggleHeaderCell />
          </HeaderRow>
        </TableHead>
        <TableBody>
          {DIALOGS_CONFIRMATIONS_OPTIONS.map((option) => {
            const isVisible = dialogVisibilityById[option.id] ?? option.defaultVisible;

            return (
              <DialogSettingsRow
                key={option.id}
                option={option}
                isVisible={isVisible}
                onToggleDialogVisibility={onToggleDialogVisibility}
              />
            );
          })}
        </TableBody>
      </Table>
    </DialogsTable>
  );
};

DialogSettingsTable.displayName = 'DialogSettingsTable';
